export const STATUS = {
  CONFIRMED: 'Confirmado',
  DRAFT: 'En Borrador'
};
